module.exports = __webpack_public_path__ + "img/ic-visa-electron-no-color.9711addf.svg";